(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/tournament-list-item.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/tournament-list-item.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const formatCurrency = svs.utils.format.Currency;
const useFormattedDateTime = svs.poker_react.components.upcomingEvents.useFormattedDateTime;
const pokerHome = svs.core.urlMapping.get('pokerHome');
const TournamentListItem = _ref => {
  let tournamentId = _ref.tournamentId,
    registrationEndTime = _ref.registrationEndTime,
    name = _ref.name,
    buyIn = _ref.buyIn,
    registrationCount = _ref.registrationCount,
    onClick = _ref.onClick,
    startTime = _ref.startTime,
    isLateReg = _ref.isLateReg,
    currency = _ref.currency;
  const _useFormattedDateTime = useFormattedDateTime({
      registrationEndTime,
      startTime,
      isLateReg
    }),
    timeLabel = _useFormattedDateTime.timeLabel,
    dateLabel = _useFormattedDateTime.dateLabel;
  const buyInString = currency === 'SEK' ? "".concat(formatCurrency(buyIn), " kr") : "\u20AC".concat(formatCurrency(buyIn));
  return React.createElement("li", {
    "aria-live": "off",
    className: "tournament-list-item"
  }, React.createElement("a", {
    "aria-label": "Anm\xE4lan till ".concat(name),
    className: "tournament-list-item-wrapper",
    href: "".concat(pokerHome, "/spela"),
    key: tournamentId,
    onClick: e => {
      e.preventDefault();
      onClick(tournamentId, name);
    }
  }, React.createElement("div", {
    className: "date-container fc-poker-100"
  }, React.createElement("div", null, dateLabel), React.createElement("div", {
    className: "f-bold"
  }, timeLabel)), React.createElement("div", {
    className: "info-container"
  }, React.createElement("div", null, React.createElement("div", {
    className: "f-bold fc-poker-100"
  }, name), React.createElement("div", {
    className: "fc-poker-200"
  }, "Ink\xF6p ".concat(buyInString, " | ").concat(registrationCount, " anm\xE4lda"))), React.createElement(Icon, {
    className: "arrow-icon",
    color: "fc-poker-200",
    icon: "menu-right"
  }))));
};
setGlobal('svs.poker_react.components.upcomingEvents.TournamentListItem', TournamentListItem);

 })(window);